(function($) {
	var prodMenu = {
		init: function() {
			var base = this;
			base.selectors();
			base.events();
		},
		selectors: function() {
			var base = this;
			base.productMenu = $(".centerMenu");
			base.productMenuFirstSubs = $(".centerMenu > li");
			base.productMenuAllMenuItemLinks = $(".centerMenu .menu a");
			base.productMenuFirstLevelLinks = $(".centerMenu > li > a");
			base.productMenuFirstLevelSubmenu = $(".centerMenu > li > .menu-wrapper");
			base.productMenuFirstLevelSubmenus = $(
				".centerMenu > li > .menu-wrapper > ul.menu"
			);
			base.productMenuCustomAccordion = $(".custom-accordion-menu");
			base.productMenuCustomAccordionLink = $(".custom-accordion-menu a");
			base.productMenuIcon = $(".menu-has-children-icon");
			base.selectProductItemBygg = $(
				".centerMenu > #menu-item-507 > .menu-wrapper > ul.menu"
			);
			base.selectProductItemFinn = $(
				".centerMenu > #menu-item-508 > .menu-wrapper > ul.menu"
			);
			base.selectProductItemKontakt = $(
				".centerMenu > #menu-item-506 > .menu-wrapper > ul.menu"
			);
		},
		events: function() {
			var base = this;

			jQuery(function($) {
				base.productMenuCustomAccordion.each(function() {
					if (
						$(this)
							.parent()
							.hasClass("current-menu-parent") ||
						$(this)
							.parent()
							.hasClass("current-menu-item")
					) {
						$(this).addClass("open-custom-accordion-menu");
					}
				});
			});

			base.productMenuFirstLevelLinks.on("mouseenter", function(e) {
				$(this).addClass("hover");
				base.productMenuFirstLevelSubmenu.hide();
				$(this)
					.siblings(".menu-wrapper")
					.css("display", "flex");
			});
			base.productMenuFirstLevelLinks.on("mouseleave", function(e) {
				$(this).removeClass("hover");
			});

			base.productMenuFirstLevelSubmenu.on("mouseleave", function(e) {
				base.productMenuFirstLevelLinks.removeClass("hover");
				$(this).hide();
			});

			base.productMenuFirstSubs.on("mouseleave", function(e) {
				$(this)
					.children(".menu-wrapper")
					.hide();
			});
		}
	};

	var ProductMenu = Object.create(prodMenu);
	ProductMenu.init();

	$.fn.extend({
		list2Columns: function(numCols) {
			var listItems = $(this).children();
			var numListItems = listItems.length;
			var numItemsPerCol = Math.round(2);

			var currentColNum = 1,
				currentItemNumber = 0,
				i = 0;

			var fragment = document.createDocumentFragment();
			for (i = 1; i <= numCols; i++) {
				var ul = document.createElement("ul");
				var numberedClass = "list-column-" + i;
				ul.classList.add("menu", "list-column", numberedClass);
				fragment.appendChild(ul);
			}

			listItems.each(function(i, v) {
				if (currentColNum > numCols) {
					currentColNum = 1;
				}
				fragment.querySelector(".list-column-" + currentColNum).appendChild(v);
				currentColNum++;
			});

			$(this)
				.parent()
				.append(fragment);
			$(this).remove();
		}
	});
})(jQuery);
